export const CREATE_HITO_TIPO = `
  mutation createHitoTipo($input: CreateHitoTipoInput!, $tenant_id: Int!) {
    createHitoTipo(input: $input, tenant_id: $tenant_id) {
      __typename
      ... on HitoTipo {
        id
        name
        code
        category_hito
        description
        vigencia_type
        requires_year
        impact_type
        allow_event
        en_timeline
        icon
        subtype_enabled
        active
        vistage20_id
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const UPDATE_HITO_TIPO = `
  mutation updateHitoTipo($input: UpdateHitoTipoInput!, $tenant_id: Int!) {
    updateHitoTipo(input: $input, tenant_id: $tenant_id) {
      __typename
      ... on HitoTipo {
        id
        name
        code
        category_hito
        description
        vigencia_type
        requires_year
        impact_type
        allow_event
        en_timeline
        icon
        subtype_enabled
        active
        vistage20_id
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const DELETE_HITO_TIPO = `
  mutation deleteHitoTipo($id: Int!, $tenant_id: Int!) {
    deleteHitoTipo(id: $id, tenant_id: $tenant_id) {
      __typename
      ... on HitoTipo {
        id
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;
